webpackJsonp([1],{

/***/ "+GNZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");
// LineChart.js


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Doughnut */],
  mounted: function mounted() {
    this.renderChart({
      labels: ['Programowanie', 'Unix', 'Matematyka I', 'Elektronika', 'Algebra'],
      datasets: [{
        label: '',
        data: [10, 5, 7, 2, 11]
      }]
    }, { responsive: true, maintainAspectRatio: false });
  }
});

/***/ }),

/***/ "+X3q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/yRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__("diQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f59490d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__("snBP");
function injectStyle (ssrContext) {
  __webpack_require__("um4D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f59490d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1/oy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1Umz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1tc7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2d5O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2koP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");
// LineChart.js


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  mounted: function mounted() {
    var _this = this;

    this.$http.get('http://arrowtotherest.azurewebsites.net/api/Statistics/GetMonthCompletions', {
      headers: {
        Authorization: 'Bearer ' + this.$cookie.get('skyrim_token')
      }
    }).then(function (response) {
      // get body data
      console.log(response.body);

      var self = _this;
      var qestFreq = {
        labels: [],
        datasets: [{
          label: 'Quest Frequency',
          data: []
        }]
      };
      response.body.forEach(function (reportElement) {
        qestFreq.labels.push(reportElement.monthName);
        qestFreq.datasets[0].data.push(reportElement.completionCount);
        self.renderChart(qestFreq, { responsive: true, maintainAspectRatio: false });
      });
    }, function (response) {
      _this.$snotify.error('Unable to download quest freqency data', 'error');
      _this.error = response.error;
    });
  }
});

/***/ }),

/***/ "3GDu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__ = __webpack_require__("fGNU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0468d377_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__("wc3Z");
function injectStyle (ssrContext) {
  __webpack_require__("SW5X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0468d377"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0468d377_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Rfx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5ZbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__("kXiA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_248ee855_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__("KEg3");
function injectStyle (ssrContext) {
  __webpack_require__("1Umz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_248ee855_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5cLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__("Vj7G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1eff4dc3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__("ngEZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1eff4dc3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "76Di":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"calendar",attrs:{"id":"calendar"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7ARk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7e19":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__QuestChart_js__ = __webpack_require__("2koP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FocusChart_js__ = __webpack_require__("A+KS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PointsChart_js__ = __webpack_require__("VSbQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TaskNumberChart_js__ = __webpack_require__("+GNZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'line-chart': __WEBPACK_IMPORTED_MODULE_0__QuestChart_js__["a" /* default */],
    'focus-chart': __WEBPACK_IMPORTED_MODULE_1__FocusChart_js__["a" /* default */],
    'points-chart': __WEBPACK_IMPORTED_MODULE_2__PointsChart_js__["a" /* default */],
    'task-chart': __WEBPACK_IMPORTED_MODULE_3__TaskNumberChart_js__["a" /* default */]
  }
});

/***/ }),

/***/ "8AuC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"login-form"}},[_c('h1',{staticClass:"apkName"},[_vm._v("SessionBorn")]),_vm._v(" "),_c('div',{staticClass:"holder"},[_c('div',{staticClass:"form-signin"},[_c('h2',{staticClass:"form-signin-heading"},[_vm._v("Please sign in")]),_vm._v(" "),_c('label',{staticClass:"sr-only",attrs:{"for":"inputLogin"}},[_vm._v("Login")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.login),expression:"credentials.login"}],staticClass:"form-control",attrs:{"id":"inputLogin","placeholder":"Login","required":"","autofocus":""},domProps:{"value":(_vm.credentials.login)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "login", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"sr-only",attrs:{"for":"inputPassword"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.password),expression:"credentials.password"}],staticClass:"form-control",attrs:{"type":"password","id":"inputPassword","placeholder":"Password","required":""},domProps:{"value":(_vm.credentials.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "password", $event.target.value)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary btn-block",attrs:{"type":"submit"},on:{"click":function($event){_vm.submit()}}},[_vm._v("Sign in")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8Uc3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep__ = __webpack_require__("MqC/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fullcalendar__ = __webpack_require__("olwm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fullcalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fullcalendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);







/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        events: {
            default: function _default() {
                return [];
            }
        },

        eventSources: {
            default: function _default() {
                return [];
            }
        },

        editable: {
            default: function _default() {
                return true;
            }
        },

        selectable: {
            default: function _default() {
                return true;
            }
        },

        selectHelper: {
            default: function _default() {
                return true;
            }
        },

        header: {
            default: function _default() {
                return {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'month,agendaWeek,agendaDay'
                };
            }
        },

        defaultView: {
            default: function _default() {
                return 'agendaWeek';
            }
        },

        sync: {
            default: function _default() {
                return false;
            }
        },

        config: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },

    computed: {
        defaultConfig: function defaultConfig() {
            var self = this;
            return {
                header: this.header,
                defaultView: this.defaultView,
                editable: this.editable,
                selectable: this.selectable,
                selectHelper: this.selectHelper,
                aspectRatio: 2,
                timeFormat: 'HH:mm',
                events: this.events,
                eventSources: this.eventSources,

                eventRender: function eventRender() {
                    if (this.sync) {
                        self.events = cal.fullCalendar('clientEvents');
                    }

                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }

                    self.$emit.apply(self, ['event-render'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventDestroy: function eventDestroy(event) {
                    if (this.sync) {
                        self.events = cal.fullCalendar('clientEvents');
                    }
                },
                eventClick: function eventClick() {
                    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                        args[_key2] = arguments[_key2];
                    }

                    self.$emit.apply(self, ['event-selected'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventDrop: function eventDrop() {
                    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                        args[_key3] = arguments[_key3];
                    }

                    self.$emit.apply(self, ['event-drop'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventResize: function eventResize() {
                    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                        args[_key4] = arguments[_key4];
                    }

                    self.$emit.apply(self, ['event-resize'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                dayClick: function dayClick() {
                    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                        args[_key5] = arguments[_key5];
                    }

                    self.$emit.apply(self, ['day-click'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                select: function select(start, end, jsEvent, view, resource) {
                    self.$emit('event-created', {
                        start: start,
                        end: end,
                        allDay: !start.hasTime() && !end.hasTime(),
                        view: view,
                        resource: resource
                    });
                }
            };
        }
    },

    mounted: function mounted() {
        var _this = this;

        var cal = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el),
            self = this;

        this.$on('remove-event', function (event) {
            if (event && event.hasOwnProperty('id')) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEvents', event.id);
            } else {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEvents', event);
            }
        });

        this.$on('rerender-events', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('rerenderEvents');
        });

        this.$on('refetch-events', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('refetchEvents');
        });

        this.$on('render-event', function (event) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('renderEvent', event);
        });

        this.$on('reload-events', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEvents');
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('addEventSource', _this.events);
        });

        this.$on('rebuild-sources', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEventSources');
            _this.eventSources.map(function (event) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('addEventSource', event);
            });
        });

        cal.fullCalendar(__WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep___default()(this.config, this.defaultConfig));
    },


    methods: {
        fireMethod: function fireMethod() {
            var _$;

            return (_$ = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el)).fullCalendar.apply(_$, arguments);
        }
    },

    watch: {
        events: {
            deep: true,
            handler: function handler(val) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).fullCalendar('removeEvents');
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).fullCalendar('addEventSource', this.events);
            }
        },
        eventSources: {
            deep: true,
            handler: function handler(val) {
                this.$emit('rebuild-sources');
            }
        }
    },

    beforeDestroy: function beforeDestroy() {
        this.$off('remove-event');
        this.$off('rerender-events');
        this.$off('refetch-events');
        this.$off('render-event');
        this.$off('reload-events');
        this.$off('rebuild-sources');
    }
});

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A+KS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");
// LineChart.js


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* Radar */],
  mounted: function mounted() {
    this.renderChart({
      labels: ['Programowanie', 'Unix', 'Matematyka I', 'Elektronika', 'Algebra'],
      datasets: [{
        label: '',
        data: [100, 85, 70, 90, 30]
      }]
    }, { responsive: true, maintainAspectRatio: false });
  }
});

/***/ }),

/***/ "BrmH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quizContainer",attrs:{"id":"container"}},[_c('h1',[_vm._v(_vm._s(_vm.quiz.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.quiz.description))]),_vm._v(" "),_c('form',{ref:"quizForm",on:{"submit":function($event){$event.preventDefault();return _vm.checkQuiz($event)}}},[_vm._l((_vm.quiz.questions),function(question){return _c('div',{staticClass:"question"},[_c('div',{staticClass:"panel panel-default answerPanel"},[_c('div',{staticClass:"panel-heading"},[_vm._v(_vm._s(question.question))]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"row"},_vm._l((question.variants),function(answer){return _c('div',{staticClass:"col-sm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(question.userAnswer),expression:"question.userAnswer"}],attrs:{"type":"radio"},domProps:{"value":answer,"checked":_vm._q(question.userAnswer,answer)},on:{"change":function($event){_vm.$set(question, "userAnswer", answer)}}}),_vm._v(" "+_vm._s(answer)+"\n              ")])}))])])])}),_vm._v(" "),_c('div',{staticClass:"submitContainer"},[_c('button',{staticClass:"btn btn-warning",attrs:{"type":"submit"}},[_c('icon',{attrs:{"name":"check"}}),_vm._v("Check")],1)])],2),_vm._v(" "),_c('b-modal',{ref:"resultModal",attrs:{"title":"Quiz result"}},[_c('p',{staticClass:"my-4"},[_vm._v("\n        Your score: "+_vm._s(_vm.points)+"/"+_vm._s(_vm.all)),_c('br')]),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"variant":"success","disabled":_vm.points/_vm.all < 0.5,"size":"sm"},on:{"click":_vm.markAsFinished}},[_vm._v("\n          Finish\n        ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"info"},on:{"click":_vm.restartQuiz}},[_vm._v("\n          Restart\n        ")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("dXrS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3fe67fee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("dqBQ");
function injectStyle (ssrContext) {
  __webpack_require__("7ARk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3fe67fee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DEtk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-bar',
  data: function data() {
    return {
      scores: '123232',
      now: new Date(),
      timer: ''
    };
  },

  created: function created() {
    this.updateTime();
    this.timer = setInterval(this.updateTime, 100);
  },
  methods: {
    updateTime: function updateTime() {
      this.now = new Date();
    }
  },
  computed: {
    time_string: function time_string() {
      return this.now.toTimeString().split(' ')[0];
    }
  }
});

/***/ }),

/***/ "E4/n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scenario-detail"},[_c('h2',{staticClass:"header"},[_vm._v("Achievements")]),_vm._v(" "),_c('b-card-group',{attrs:{"columns":""}},_vm._l((_vm.achievments),function(achievment){return _c('b-card',{key:achievment.achievementName,staticClass:"tile",attrs:{"title":achievment.achievementName,"sub-title":achievment.description}},[_c('div',{staticClass:"mb-0 row",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"col-6"},[_c('icon',{attrs:{"name":"diamond"}})],1)])])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GJyD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statistics_vue__ = __webpack_require__("7e19");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00dccc18_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Statistics_vue__ = __webpack_require__("ssol");
function injectStyle (ssrContext) {
  __webpack_require__("QxmS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00dccc18"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statistics_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00dccc18_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Statistics_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H7Gg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{staticClass:"navbar navbar-expand-lg navbar-dark bg-dark fixed-top",attrs:{"id":"navbar","toggleable":"md","type":"dark","variant":"info"}},[_c('b-navbar-toggle',{attrs:{"target":"nav_collapse"}}),_vm._v(" "),_c('b-navbar-brand',{staticClass:"brand",attrs:{"href":"/"}},[_vm._v("SessionBorn")]),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"nav_collapse"}},[_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('b-nav-text',{staticClass:"line"},[_c('icon',{attrs:{"name":"clock-o"}}),_vm._v(" Time:\n        "+_vm._s(_vm.time_string)+"\n      ")],1)],1),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('b-nav-item',{staticClass:"line",attrs:{"href":"#"}},[_c('icon',{attrs:{"name":"sign-out"}}),_vm._v(" Logout")],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HtFr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar_container",attrs:{"id":"container_calendar"}},[_c('full-calendar',{attrs:{"events":_vm.events,"config":_vm.config}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Id91":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JxyX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K8Xc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Achievments_vue__ = __webpack_require__("MgeI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_588d526c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Achievments_vue__ = __webpack_require__("E4/n");
function injectStyle (ssrContext) {
  __webpack_require__("JxyX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-588d526c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Achievments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_588d526c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Achievments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KEg3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LRud":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__ = __webpack_require__("icVI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Rewards',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      rewards: null,
      error: null,
      rewardNow: {
        id: 0,
        name: '',
        canBuy: false
      }
    };
  },

  methods: {
    getRewardModal: function getRewardModal(id) {
      var _this = this;

      this.$http.get('http://arrowtotherest.azurewebsites.net/api/Reward/CanBuy?rewardID=' + id, {
        headers: {
          Authorization: 'Bearer ' + this.$cookie.get('skyrim_token')
        }
      }).then(function (response) {
        if (response.body.isSuccess) {
          _this.rewardNow.id = id;
          _this.rewardNow.name = _this.rewards.find(function (elem) {
            return elem.RewardID === id;
          }).Name;
          _this.rewardNow.canBuy = response.body.isSuccess;
        }
      }, function (response) {
        _this.error = response.error;
      });
      this.$refs.rewardModal.show();
    },
    sendReward: function sendReward(id) {
      var _this2 = this;

      this.$http.post('http://arrowtotherest.azurewebsites.net/api/Reward/BuyReward?rewardID=' + id, {}, {
        headers: {
          Authorization: 'Bearer ' + this.$cookie.get('skyrim_token')
        }
      }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__["a" /* EventBus */].$emit('reward-send');
        console.log('EMITED BUS');
        _this2.$refs.rewardModal.hide();
      }, function (response) {
        _this2.error = response.error;
      });
    },
    clearModal: function clearModal() {
      this.rewardNow.id = 0;
      this.rewardNow.name = '';
      this.rewardNow.canBuy = false;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$http.get('http://arrowtotherest.azurewebsites.net/api/Reward', {
      headers: {
        Authorization: 'Bearer ' + this.$cookie.get('skyrim_token')
      }
    }).then(function (response) {
      // get body data
      _this3.rewards = response.body;
    }, function (response) {
      _this3.error = response.error;
    });
  }
});

/***/ }),

/***/ "LuhF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__ = __webpack_require__("icVI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_es_components_nav_nav_form__ = __webpack_require__("LHeC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function shuffleArray(array) {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var _ref = [array[j], array[i]];
    array[i] = _ref[0];
    array[j] = _ref[1];
  }
}
/* harmony default export */ __webpack_exports__["a"] = ({
  components: { NavForm: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_es_components_nav_nav_form__["a" /* default */] },
  name: 'quiz',
  data: function data() {
    return {
      quiz: {},
      points: 0,
      all: 0,
      empty: 0
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.$http.get('http://arrowtotherest.azurewebsites.net/api/Quiz?quizID=' + this.$route.params.id, {
      headers: {
        Authorization: 'Bearer ' + this.$cookie.get('skyrim_token')
      }
    }).then(function (response) {
      // get body data
      console.log(response.body);
      _this.quiz = response.body;
      _this.quiz.questions.forEach(function (question) {
        shuffleArray(question.variants);
      });
    }, function (response) {
      _this.error = response.status;
    });
  },
  methods: {
    markAsFinished: function markAsFinished() {
      var _this2 = this;

      console.log('sent');
      var answer = {
        quizID: parseInt(this.$route.params.id),
        score: (this.points / this.all).toFixed(2) * 100
      };
      console.log(answer);
      this.$http.post('http://arrowtotherest.azurewebsites.net/Api/Quiz/Answer', answer, {
        headers: {
          Authorization: 'Bearer ' + this.$cookie.get('skyrim_token')
        }
      }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__["a" /* EventBus */].$emit('quiz-send');
        _this2.$snotify.success('You solved quiz', 'Solved');
      }, function (response) {
        _this2.$snotify.error('Please check data: ' + response.status, 'Error');
        _this2.error = response.status;
      });
      this.restartQuiz();
    },
    restartQuiz: function restartQuiz() {
      this.$refs.resultModal.hide();
      this.quiz.questions.forEach(function (question) {
        question.userAnswer = undefined;
      });
    },
    checkQuiz: function checkQuiz() {
      console.log(this.quiz);
      var points = 0;
      var empty = 0;
      var all = 0;

      this.quiz.questions.forEach(function (question) {
        all += 1;
        console.log(question);
        if (question.userAnswer === undefined) {
          empty += 1;
        } else if (question.userAnswer === question.answer) {
          points += 1;
        }
      });

      this.points = points;
      this.all = all;
      this.empty = empty;

      this.$refs.resultModal.show();
    }
  }
});

/***/ }),

/***/ "LvfT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5687592_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("QoGY");
function injectStyle (ssrContext) {
  __webpack_require__("3Rfx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d5687592"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5687592_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MgeI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Achievments',
  data: function data() {
    return {
      achievments: null,
      error: null
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.$http.get('http://arrowtotherest.azurewebsites.net/api/Achievement', {
      headers: {
        Authorization: 'Bearer ' + this.$cookie.get('skyrim_token')
      }
    }).then(function (response) {
      // get body data
      _this.achievments = response.body;
    }, function (response) {
      _this.error = response.error;
    });
  }
});

/***/ }),

/***/ "N2ME":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FullCalendar_vue__ = __webpack_require__("8Uc3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_46bf2a5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FullCalendar_vue__ = __webpack_require__("76Di");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FullCalendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_46bf2a5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FullCalendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_snotify_styles_material_css__ = __webpack_require__("2d5O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_snotify_styles_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_snotify_styles_material_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_snotify__ = __webpack_require__("HgYs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_full_calendar__ = __webpack_require__("QaH6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









 // or dark.css or simple.css



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_full_calendar__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_snotify__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('icon', __WEBPACK_IMPORTED_MODULE_12_vue_awesome_components_Icon__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] }
});

/***/ }),

/***/ "OxYU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PaFq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__ = __webpack_require__("icVI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Quests',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      quests: null,
      error: null,
      timestamp: Date.now(),
      newQuest: {
        name: '',
        scenarioId: this.$route.params.id,
        type: 0,
        dueDate: Date.now(),
        Latitude: 0.0,
        Longitude: 0.0,
        description: '',
        points: 0
      },
      questType: [{
        text: 'Test',
        value: 1
      }, {
        text: 'Exam',
        value: 2
      }, {
        text: 'Meeting',
        value: 3
      }, {
        text: 'Quiz',
        value: 4
      }],
      questNow: {
        id: 0,
        name: '',
        canSolve: false
      }
    };
  },

  watch: {
    timestamp: function timestamp(val) {
      this.newQuest.dueDate = val.toLocaleString();
    }
  },
  methods: {
    updateTime: function updateTime(date) {
      var dayConst = 86400 * 1000;
      return Math.floor((Date.parse(date) - Date.now()) / dayConst);
    },
    checkMapParams: function checkMapParams(lan, lon) {
      return lan == null || lon == null;
    },
    mapLink: function mapLink(lan, lon, name) {
      return '/#/map/' + lon + '/' + lan + '/' + name.replace(' ', '%20');
    },
    sendQuest: function sendQuest() {
      var _this = this;

      this.newQuest.dueDate = this.newQuest.dueDate.toLocaleString();
      console.log(this.newQuest);
      this.$http.post('http://arrowtotherest.azurewebsites.net/api/Quest/add', this.newQuest, {
        headers: {
          Authorization: 'Bearer ' + this.$cookie.get('skyrim_token')
        }
      }).then(function (response) {
        _this.$snotify.success('Quest added', 'Success');
        _this.clearQuestModal();
        _this.getQuests();
      }, function (response) {
        _this.$snotify.error('Please check data: ' + response.status, 'Error');
        _this.error = response.status;
      });
    },
    clearQuestModal: function clearQuestModal() {
      this.newQuest = {
        name: '',
        scenarioId: this.$route.params.id,
        type: '',
        dueDate: Date.now(),
        Latitude: 0.0,
        Longitude: 0.0,
        description: '',
        points: 0
      };
    },
    getQuests: function getQuests() {
      var _this2 = this;

      this.$http.get('http://arrowtotherest.azurewebsites.net/api/Scenario/' + this.$route.params.id + '/Quests', {
        headers: {
          Authorization: 'Bearer ' + this.$cookie.get('skyrim_token')
        }
      }).then(function (response) {
        // get body data
        _this2.quests = response.body;
      }, function (response) {
        _this2.error = response.status;
      });
    },
    getSolveQuestModal: function getSolveQuestModal(id) {
      var _this3 = this;

      this.$http.post('http://arrowtotherest.azurewebsites.net/api/Quest/' + id + '/canComplete', {
        questID: id
      }, {
        headers: {
          Authorization: 'Bearer ' + this.$cookie.get('skyrim_token')
        }
      }).then(function (response) {
        if (response.body.isSuccess) {
          _this3.questNow.id = id;
          _this3.questNow.name = _this3.quests.find(function (elem) {
            return elem.id === id;
          }).Name;
          _this3.questNow.canSolve = response.body.isSuccess;
        }
      }, function (response) {
        _this3.error = response.status;
      });
      this.$refs.solveQuestModal.show();
    },
    solveQuest: function solveQuest(id) {
      var _this4 = this;

      this.$http.post('http://arrowtotherest.azurewebsites.net/api/Quest/' + id + '/complete', {
        questID: id
      }, {
        headers: {
          Authorization: 'Bearer ' + this.$cookie.get('skyrim_token')
        }
      }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__["a" /* EventBus */].$emit('reward-send');
        console.log('EMITED BUS');
        _this4.$refs.solveQuestModal.hide();
        _this4.getQuests();
      }, function (response) {
        _this4.error = response.status;
      });
    },
    clearModal: function clearModal() {
      this.questNow.id = 0;
      this.questNow.name = '';
      this.questNow.canSolve = false;
    }
  },
  mounted: function mounted() {
    this.getQuests();
    __WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__["a" /* EventBus */].$on('quiz-send', this.getQuests);
  }
});

/***/ }),

/***/ "QoGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.authFlag)?[_c('navbar'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('sidebar'),_vm._v(" "),_c('div',{staticClass:"col-sm-10 main"},[_c('router-view')],1)],1)]:[_c('login-form')],_vm._v(" "),_c('vue-snotify')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QvV/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scenario-detail"},[_c('h2',{staticClass:"header"},[_vm._v("Rewards")]),_vm._v(" "),_c('b-card-group',{attrs:{"columns":""}},_vm._l((_vm.rewards),function(reward){return _c('b-card',{key:reward.RewardID,staticClass:"tile",attrs:{"title":reward.Name,"sub-title":reward.Description}},[_c('div',{staticClass:"mb-0 row",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"col-6"},[_c('icon',{attrs:{"name":"star"}})],1),_vm._v(" "),_c('div',{staticClass:"col-6 text-right"},[_c('b',[_vm._v(_vm._s(reward.Cost))])])]),_vm._v(" "),_c('b-button-group',[_c('b-button',{attrs:{"variant":"success","size":"sm"},on:{"click":function($event){_vm.getRewardModal(reward.RewardID)}}},[_vm._v("Get reward")])],1)],1)})),_vm._v(" "),_c('b-modal',{ref:"rewardModal",staticClass:"reward-dialog",attrs:{"hide-footer":"","id":"RewardModal","title":_vm.rewardNow.name},on:{"hidden":function($event){_vm.clearModal()}}},[_c('p',{staticClass:"my-4"},[_vm._v("Do you wanna get your reward?")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success","block":"","disabled":!_vm.rewardNow.canBuy},on:{"click":function($event){_vm.sendReward(_vm.rewardNow.id)}}},[_vm._v("Acquire reward")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QxmS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SW5X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TGvd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__("aEfQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8528e5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__("gUd1");
function injectStyle (ssrContext) {
  __webpack_require__("uFdb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f8528e5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8528e5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U6Mb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quiz_vue__ = __webpack_require__("LuhF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3446ca8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quiz_vue__ = __webpack_require__("BrmH");
function injectStyle (ssrContext) {
  __webpack_require__("ckBe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d3446ca8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quiz_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3446ca8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quiz_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VSbQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");
// LineChart.js


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  mounted: function mounted() {
    this.renderChart({
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [{
        label: '',
        data: [15, 40, 60, 100, 32, 56, 32]
      }]
    }, { responsive: true, maintainAspectRatio: false });
  }
});

/***/ }),

/***/ "Ww+8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rewards_vue__ = __webpack_require__("LRud");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_638ca762_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rewards_vue__ = __webpack_require__("QvV/");
function injectStyle (ssrContext) {
  __webpack_require__("fDKd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-638ca762"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rewards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_638ca762_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rewards_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YI6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__("jIen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1955ba6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__("OxYU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1955ba6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YT0m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'calendar',
  data: function data() {
    return {
      events: []
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.$http.get('http://arrowtotherest.azurewebsites.net/api/Quest', {
      headers: {
        Authorization: 'Bearer ' + this.$cookie.get('skyrim_token')
      }
    }).then(function (response) {
      // get body data
      console.log(response.body);
      var self = _this;
      _this.events = [];
      response.body.forEach(function (question) {
        self.events.push({
          title: question.name,
          start: question.date,
          description: question.description,
          allDay: false
        });
      });
    }, function (response) {
      _this.error = response.status;
    });
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard__ = __webpack_require__("TGvd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Map__ = __webpack_require__("3GDu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Quests__ = __webpack_require__("pOHZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Rewards__ = __webpack_require__("Ww+8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Achievments__ = __webpack_require__("K8Xc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Quiz__ = __webpack_require__("U6Mb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Statistics__ = __webpack_require__("GJyD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Calendar__ = __webpack_require__("iyFI");










// import Toastr
// import toastr less file: need webpack less-loader
// Register vue component

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Dashboard__["a" /* default */]
  }, {
    path: '/scenario/:id',
    name: 'Quests',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Quests__["a" /* default */]
  }, {
    path: '/map/:lon/:lat/:title',
    name: 'Map',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Map__["a" /* default */]
  }, {
    path: '/map',
    name: 'Map_all',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Map__["a" /* default */]
  }, {
    path: '/rewards',
    name: 'Rewards',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Rewards__["a" /* default */]
  }, {
    path: '/achievments',
    name: 'Achievments',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Achievments__["a" /* default */]
  }, {
    path: '/stats',
    name: 'Stats',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Statistics__["a" /* default */]
  }, {
    path: '/quiz/:id',
    name: 'Quiz',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Quiz__["a" /* default */]
  }, {
    path: '/calendar',
    name: 'Calendar',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Calendar__["a" /* default */]
  }]
}));

/***/ }),

/***/ "ZZbc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scenario-detail"},[_c('div',{staticClass:"row"},[_c('h2',{staticClass:"header"},[_vm._v("Scenario no. "+_vm._s(_vm.$route.params.id))]),_vm._v(" "),_c('div',{staticClass:"mx-3 py-1"},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.addQuestModal",modifiers:{"addQuestModal":true}}],attrs:{"size":"sm","variant":"success"}},[_vm._v("Add new quest")])],1)]),_vm._v(" "),_c('b-card-group',{attrs:{"columns":""}},_vm._l((_vm.quests),function(quest){return _c('b-card',{key:quest.id,staticClass:"tile",attrs:{"title":quest.name,"sub-title":quest.description}},[_c('div',{staticClass:"mb-0 row",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"col-6"},[_c('b',[_vm._v("Points:")]),_vm._v(" "+_vm._s(quest.points))]),_vm._v(" "),_c('div',{staticClass:"col-6 text-right"},[_c('b',[_vm._v(_vm._s(quest.type))])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[(quest.completed)?_c('small',{staticClass:"text-muted"},[_vm._v("Finished quest!")]):_c('small',{staticClass:"due-date"},[_vm._v(_vm._s(_vm.updateTime(quest.dueDate))+" days left")])]),_vm._v(" "),_c('b-button-group',[(quest.isQuiz)?_c('b-button',{attrs:{"variant":"info","size":"sm","disabled":quest.completed,"to":'/quiz/' + quest.id}},[_vm._v("Solve quiz")]):_c('b-button',{attrs:{"variant":"success","size":"sm","disabled":quest.completed},on:{"click":function($event){_vm.getSolveQuestModal(quest.id)}}},[_vm._v("Complete")]),_vm._v(" "),_c('b-button',{staticClass:"card-link",attrs:{"variant":"secondary","size":"sm","href":_vm.mapLink(quest.Latitude,quest.Longitude,quest.name),"disabled":_vm.checkMapParams(quest.Latitude,quest.Longitude)}},[_vm._v("Show on map")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"danger","size":"sm","disabled":quest.completed}},[_vm._v("Resign")])],1)],1)})),_vm._v(" "),_c('b-modal',{attrs:{"id":"addQuestModal","title":"Add new quest"},on:{"ok":_vm.sendQuest,"shown":_vm.clearQuestModal}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"newQuestName"}},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newQuest.name),expression:"newQuest.name"}],staticClass:"form-control",attrs:{"id":"newQuestName","placeholder":"Name","required":"","autofocus":""},domProps:{"value":(_vm.newQuest.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newQuest, "name", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"newQuestDesc"}},[_vm._v("Description")]),_c('br'),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.newQuest.description),expression:"newQuest.description"}],staticClass:"form-control",attrs:{"rows":"3","id":"newQuestDesc"},domProps:{"value":(_vm.newQuest.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newQuest, "description", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"newQuestType"}},[_vm._v("Type")]),_vm._v(" "),_c('b-form-select',{staticClass:"form-control",attrs:{"id":"newQuestType","name":"newQuestType","options":_vm.questType},model:{value:(_vm.newQuest.type),callback:function ($$v) {_vm.$set(_vm.newQuest, "type", $$v)},expression:"newQuest.type"}}),_vm._v(" "),_c('label',{attrs:{"for":"newQuestDate"}},[_vm._v("Due date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.timestamp),expression:"timestamp"}],staticClass:"form-control",attrs:{"type":"datetime-local","id":"newQuestDate","placeholder":"Due date","required":"","autofocus":""},domProps:{"value":(_vm.timestamp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.timestamp=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"newQuestPoints"}},[_vm._v("Points")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newQuest.points),expression:"newQuest.points"}],staticClass:"form-control",attrs:{"type":"number","id":"newQuestPoints","min":"0","placeholder":"ECTS points","required":"","autofocus":""},domProps:{"value":(_vm.newQuest.points)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newQuest, "points", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('label',{attrs:{"for":"newQuestLat"}},[_vm._v("Latitude")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newQuest.Latitude),expression:"newQuest.Latitude"}],staticClass:"form-control",attrs:{"type":"number","id":"newQuestLat","min":"0","placeholder":"Latitude"},domProps:{"value":(_vm.newQuest.Latitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newQuest, "Latitude", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('label',{attrs:{"for":"newQuestLon"}},[_vm._v("Longitude")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newQuest.Longitude),expression:"newQuest.Longitude"}],staticClass:"form-control",attrs:{"type":"number","id":"newQuestLon","min":"0","placeholder":"Longitude"},domProps:{"value":(_vm.newQuest.Longitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newQuest, "Longitude", $event.target.value)}}})])])],1)]),_vm._v(" "),_c('b-modal',{ref:"solveQuestModal",staticClass:"quiz-dialog",attrs:{"hide-footer":"","id":"SolveQuestModal","title":_vm.questNow.name},on:{"hidden":function($event){_vm.clearModal()}}},[_c('p',{staticClass:"my-4"},[_vm._v("Do you wanna finish this quest?")]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"success","block":"","disabled":!_vm.questNow.canSolve},on:{"click":function($event){_vm.solveQuest(_vm.questNow.id)}}},[_vm._v("Acquire reward")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aEfQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      scenarios: null,
      error: null,
      newScenario: {
        scenarioName: '',
        scenarioDesc: ''
      }
    };
  },

  methods: {
    addScenario: function addScenario() {
      var _this = this;

      this.$http.post('http://arrowtotherest.azurewebsites.net/api/Scenario/add', this.newScenario, {
        headers: {
          Authorization: 'Bearer ' + this.$cookie.get('skyrim_token')
        }
      }).then(function (response) {
        _this.$snotify.success('Scenario added', 'Success');
        _this.newScenario.scenarioDesc = '';
        _this.newScenario.scenarioName = '';
        _this.$refs.addScenarioModal.hide();
        _this.getScenario();
      }, function (response) {
        _this.$snotify.error('Please check data: ' + response.status, 'Error');
        _this.error = response.status;
      });
    },
    cancelScenarioAdd: function cancelScenarioAdd() {
      this.newScenario.scenarioDesc = '';
      this.newScenario.scenarioName = '';
      this.$refs.addScenarioModal.hide();
    },
    displayScenarioModal: function displayScenarioModal() {
      this.$refs.addScenarioModal.show();
    },
    getScenario: function getScenario() {
      var _this2 = this;

      /* this.$http.interceptors.get(function (request) {
        request.headers.set('X-CSRF-TOKEN', this.$cookie.get('skyrim_token'))
        request.headers.set('Authorization', 'Bearer TOKEN')
      }) */
      this.$http.get('http://arrowtotherest.azurewebsites.net/api/Scenario', {
        headers: {
          Authorization: 'Bearer ' + this.$cookie.get('skyrim_token')
        }
      }).then(function (response) {
        // get body data
        _this2.scenarios = response.body;
      }, function (response) {
        _this2.error = response.error;
      });
    }
  },
  mounted: function mounted() {
    this.getScenario();
  }
});

/***/ }),

/***/ "ckBe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dXrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
            return false;
          }
          return true;
        }
        console.warn('Invalid prop: prop "name" is required.');
        return false;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ "dqBQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.klass,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path,i){return _c('path',_vm._b({key:("path-" + i)},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon,i){return _c('polygon',_vm._b({key:("polygon-" + i)},'polygon',polygon,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f3NK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__ = __webpack_require__("icVI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Sidebar',
  data: function data() {
    return {
      user: {
        name: '',
        photoLink: '',
        lvl: 0,
        exp: 0 },
      menu: [{ link: '/', name: 'Dashboard', icon: 'home' }, { link: '/#/rewards', name: 'Awards', icon: 'star' }, { link: '/#/map', name: 'Map', icon: 'map' }, { link: '/#/stats', name: 'Statistics', icon: 'area-chart' }, { link: '/#/achievments', name: 'Achievements', icon: 'diamond' }, { link: '/#/calendar', name: 'Calendar', icon: 'calendar' }]
    };
  },

  methods: {
    getSidebar: function getSidebar() {
      var _this = this;

      this.$http.get('http://arrowtotherest.azurewebsites.net/api/Sidebar', {
        headers: {
          Authorization: 'Bearer ' + this.$cookie.get('skyrim_token')
        }
      }).then(function (response) {
        _this.user = response.body;
      }, function (response) {
        _this.error = response.error;
      });
    }
  },
  mounted: function mounted() {
    this.getSidebar();
    __WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__["a" /* EventBus */].$on('reward-send', this.getSidebar);
  }
});

/***/ }),

/***/ "fDKd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fGNU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_0_vue2_google_maps__, {
  load: {
    key: 'AIzaSyC29gafI4xkrUgA-P_ezy6NIOuwLfNWCTU',
    libraries: 'places,drawing,visualization'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'map_comp',
  data: function data() {
    return {
      center: { lat: 0.0, lng: 0.0 },
      markers: []
    };
  },

  mounted: function mounted() {
    var _this = this;

    if (this.$route.params.lon != null && this.$route.params.lat != null) {
      var pos = { lat: Number(this.$route.params.lat), lng: Number(this.$route.params.lon) };
      this.markers = [{
        position: pos,
        title: this.$route.params.title,
        messageVisible: true
      }];
      this.center = pos;
    } else {
      this.$http.get('http://arrowtotherest.azurewebsites.net/api/Location', {
        headers: {
          Authorization: 'Bearer ' + this.$cookie.get('skyrim_token')
        }
      }).then(function (response) {
        _this.markers = [];
        var self = _this;
        console.log(response.body);
        response.body.forEach(function (quest) {
          if (quest.latitude != null && quest.longitude != null) {
            console.log(self);
            self.markers.push({
              position: { lat: quest.latitude, lng: quest.longitude },
              title: '[' + quest.scenarioTitle + ']' + quest.questTitle,
              desc: quest.description,
              messageVisible: true
            });
          }
        });

        if (self.markers.length > 0) {
          self.center = self.markers[0].position;
        }
      }, function (response) {
        _this.$snotify.error('Unable to download map data', 'Error');
        _this.error = response.error;
      });
    }
  }
});

/***/ }),

/***/ "g2+m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavBar_vue__ = __webpack_require__("DEtk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18acc47c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavBar_vue__ = __webpack_require__("H7Gg");
function injectStyle (ssrContext) {
  __webpack_require__("LvfT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18acc47c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18acc47c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gUd1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Dashboard"}},[_c('div',{staticClass:"row"},[_c('h2',{staticClass:"header"},[_vm._v("Scenarios "),_c('b-button',{staticClass:"mx-3 py-1",attrs:{"variant":"success","size":"sm"},on:{"click":_vm.displayScenarioModal}},[_vm._v(" Add scenario ")])],1)]),_vm._v(" "),_c('b-card-group',{attrs:{"columns":""}},_vm._l((_vm.scenarios),function(scenario){return _c('b-card',{key:scenario.id,staticClass:"tile",attrs:{"title":scenario.scenarioName,"sub-title":scenario.scenarioDesc}},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress-bar-fill",style:({ 'width': scenario.percentDone + '%'  })})]),_vm._v(" "),_c('router-link',{staticClass:"card-link",attrs:{"to":'scenario/' + scenario.id}},[_vm._v("See quests")]),_vm._v(" "),(scenario.completed)?_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('small',{staticClass:"text-muted"},[_vm._v("Finished scenario!")])]):_vm._e()],1)})),_vm._v(" "),_c('b-modal',{ref:"addScenarioModal",attrs:{"title":"Add scenario"}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"newScenarioName"}},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newScenario.scenarioName),expression:"newScenario.scenarioName"}],staticClass:"form-control",attrs:{"id":"newScenarioName","placeholder":"Name","required":"","autofocus":""},domProps:{"value":(_vm.newScenario.scenarioName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newScenario, "scenarioName", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"newScenarioDesc"}},[_vm._v("Description")]),_c('br'),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.newScenario.scenarioDesc),expression:"newScenario.scenarioDesc"}],staticClass:"form-control",attrs:{"rows":"5","id":"newScenarioDesc"},domProps:{"value":(_vm.newScenario.scenarioDesc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newScenario, "scenarioDesc", $event.target.value)}}})]),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"variant":"success","size":"sm"},on:{"click":_vm.addScenario}},[_vm._v("\n        Add\n      ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"info"},on:{"click":_vm.cancelScenarioAdd}},[_vm._v("\n        Cancel\n      ")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gosb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__ = __webpack_require__("pFqp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_715e8ab5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__ = __webpack_require__("8AuC");
function injectStyle (ssrContext) {
  __webpack_require__("zyLn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-715e8ab5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_715e8ab5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "icVI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),

/***/ "iyFI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__ = __webpack_require__("YT0m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d64da68_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__ = __webpack_require__("HtFr");
function injectStyle (ssrContext) {
  __webpack_require__("nslH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d64da68"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d64da68_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lZ5c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("f3NK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4888a500_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("oKfH");
function injectStyle (ssrContext) {
  __webpack_require__("+X3q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4888a500"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4888a500_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ngEZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nslH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oKfH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar col-sm-2",attrs:{"id":"sidebar"}},[_c('div',{staticClass:"user-profile px-2 my-4"},[_c('h5',{staticClass:"user-name text-uppercase"},[_vm._v(_vm._s(_vm.user.name))]),_vm._v(" "),_c('div',{staticClass:"user-photo"},[_c('img',{attrs:{"src":_vm.user.photoLink,"alt":"avatar"}})]),_vm._v(" "),_c('div',{staticClass:"user-stats row"},[_c('div',{staticClass:"col-8 user-exp"},[_vm._v(_vm._s(_vm.user.exp)+"/"+_vm._s(_vm.user.nextExp)+" EXP")]),_vm._v(" "),_c('div',{staticClass:"col-4 user-lvl"},[_vm._v(" "+_vm._s(_vm.user.lvl)+" LVL")])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('icon',{attrs:{"name":"database"}}),_vm._v(" ECTS: "+_vm._s(_vm.user.points))],1),_vm._v(" "),_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress-bar-fill",style:({ 'width': _vm.user.levelPercentage*100 + '%'  })})])]),_vm._v(" "),_c('div',{staticClass:"menu"},[_c('h6',{staticClass:"menu-header text-uppercase"},[_vm._v("Menu")]),_vm._v(" "),_c('b-nav',{attrs:{"vertical":""}},_vm._l((_vm.menu),function(item){return _c('b-nav-item',{key:item.name,staticClass:"menu-item",attrs:{"active":"","href":item.link}},[_c('div',{staticClass:"row"},[_c('span',{staticClass:"icon col-3"},[_c('icon',{attrs:{"name":item.icon}})],1),_vm._v(" "),_c('span',{staticClass:"name col-9"},[_vm._v(_vm._s(item.name))])])])}))],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pFqp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__ = __webpack_require__("icVI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      credentials: {
        login: '',
        password: ''
      },
      error: ''
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      var loginData = {
        grant_type: 'password',
        username: this.credentials.login,
        password: this.credentials.password
      };
      this.$http.post('http://arrowtotherest.azurewebsites.net/Token', loginData, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, emulateJSON: true }).then(function (response) {
        _this.$snotify.success('Success', 'Access granted');
        _this.$cookie.set('skyrim_token', response.body.access_token, response.body.expires_in);
        __WEBPACK_IMPORTED_MODULE_0__bus_event_bus_js__["a" /* EventBus */].$emit('login');
      }, function (response) {
        _this.$snotify.error('Incorrect username or password', 'Error');
      });
      // We need to pass the component's this context
      // to properly make use of http in the auth service
      // auth.login(this, credentials, 'secretquote')
    }
  },
  name: 'login-form'
});

/***/ }),

/***/ "pOHZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quests_vue__ = __webpack_require__("PaFq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57b177d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quests_vue__ = __webpack_require__("ZZbc");
function injectStyle (ssrContext) {
  __webpack_require__("1tc7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57b177d3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quests_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57b177d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quests_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "preG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__("osty");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5b62a628_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__("uYjg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5b62a628_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "snBP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ssol":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chartMainContainer",attrs:{"id":"container"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm chartContainer"},[_c('h1',[_vm._v("Quest Frequency")]),_vm._v(" "),_c('line-chart',{staticClass:"lineChart"})],1),_vm._v(" "),_c('div',{staticClass:"col-sm chartContainer"},[_c('h1',[_vm._v("Focus chart")]),_vm._v(" "),_c('focus-chart',{staticClass:"lineChart"})],1),_vm._v(" "),_c('div',{staticClass:"col-sm chartContainer"},[_c('h1',[_vm._v("Focus chart")]),_vm._v(" "),_c('task-chart',{staticClass:"lineChart"})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm chartContainer"},[_c('h1',[_vm._v("Points")]),_vm._v(" "),_c('points-chart',{staticClass:"lineChart"})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uFdb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uYjg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "um4D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "wc3Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mapContainer",attrs:{"id":"Map"}},[_c('gmap-map',{staticStyle:{"width":"100%","height":"100%"},attrs:{"center":_vm.center,"zoom":7}},_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position,"clickable":true,"draggable":false},on:{"click":function($event){m.messageVisible=!m.messageVisible}}},[_c('gmap-info-window',{attrs:{"opened":m.messageVisible}},[_c('span',{staticClass:"maptitle"},[_vm._v(" "+_vm._s(m.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(m.desc))])])],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_NavBar__ = __webpack_require__("g2+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Sidebar__ = __webpack_require__("lZ5c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LoginForm__ = __webpack_require__("gosb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bus_event_bus_js__ = __webpack_require__("icVI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    'navbar': __WEBPACK_IMPORTED_MODULE_0__components_NavBar__["a" /* default */],
    'sidebar': __WEBPACK_IMPORTED_MODULE_1__components_Sidebar__["a" /* default */],
    'login-form': __WEBPACK_IMPORTED_MODULE_2__components_LoginForm__["a" /* default */]
  },
  data: function data() {
    // this.$refs.toastr.Add('ERRROR MESSAGE')
    // this.$refs.toastr.Add('SUCCESS MESSAGE')
    return {
      authFlag: false
    };
  },

  mounted: function mounted() {
    var _this = this;

    var cookie = this.$cookie.get('skyrim_token');
    __WEBPACK_IMPORTED_MODULE_3__bus_event_bus_js__["a" /* EventBus */].$on('login', function () {
      _this.authFlag = true;
    });
    if (cookie != null) {
      this.authFlag = true;
    }
  }
});

/***/ }),

/***/ "zj2Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zyLn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.21570424e726694a05b2.js